import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customerId: 0,
  customerFirstName: '',
  customerLastName: '',
  image: '',
  email:''
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { id, customerFirstName, customerLastName, image ,email} = action.payload;
      state.customerId = id;
      state.customerFirstName = customerFirstName;
      state.customerLastName = customerLastName;
      state.image = `data:image/jpeg;base64,${image}`;
      state.email=email
    },
  }
});

// Action creators are generated for each case reducer function
export const { setUser } = userSlice.actions;

export default userSlice.reducer;
